module.exports = __webpack_public_path__ + "static/media/client-logo-4.eb84a896.jpg";